













































































import { Vue, Prop, Component } from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import MainButton from '@/shared/buttons/main-button.component.vue';
import BillingService from '@/domain/billing/service/billing.service';
import BillingDetailed from '@/domain/billing/entity/billing-detailed.entity';
import BillingInfoV2Header from './billing-info-v2-header.component.vue';
import BillingInfoV2Summary from './billing-info-v2-summary.component.vue';
import BillingInfoV2Items from './billing-info-v2-items.component.vue';

@Component({
  components: {
    MainButton,
    BillingInfoV2Header,
    BillingInfoV2Summary,
    BillingInfoV2Items,
  },
})
export default class BillingInfoV2 extends Vue {
  @Prop({
    type: String,
    required: true,
  })
  billingId!: string;

  @Prop({
    type: String,
    default: '',
  })
  businessUnitId!: string;

  private loading: boolean = true;

  private billing: BillingDetailed = new BillingDetailed();

  go(path: string): void {
    this.$router.push(path);
  }

  private loadBillingDetails(): void {
    this.loading = true;
    BillingService.getById(this.billingId)
      .then((billing: BillingDetailed) => {
        this.billing = billing;
      })
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => { this.loading = false; });
  }

  created(): void {
    this.loadBillingDetails();
  }
}
